import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { GroupDetailModel } from "./group-detail-model";

export class GroupDetailGridModel extends GroupDetailModel {
  group_student_list_id: any = 0;
 }

export class GroupDetailListingModel extends GridModel<GroupDetailGridModel> {
  student_list: any[] = [];
  alreadyAddedStudents: any[] = [];
  selectedStudents: any[] = [];
  removedStudents: any[] = [];
  batch_id: number = 0;
  currentPageData: any;
}

export class GroupDetailsGridPostParams extends GridPostParams {
    batch_id: number = null;
}
